"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getCurriedOnLoad(existingScript, callback) {
  var previousOnload = existingScript.onload || function () {};
  var curriedOnLoad = function curriedOnLoad() {
    previousOnload();
    callback();
  };

  return curriedOnLoad;
}

exports.default = getCurriedOnLoad;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-jw-player/dist/helpers/get-curried-on-load.js
// module id = 673
// module chunks = 0